import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '@material-ui/core'

import { ComposeActionTrigger as BaseActionTrigger } from 'components/ComposeOutreachMessageButton/Triggers'

export const ComposeActionTrigger = ({ trigger }: { trigger: string }) => (
  <BaseActionTrigger
    trigger={trigger}
    size="large"
  >
    <FontAwesomeIcon
      icon={faPlus}
      aria-hidden
    />
    <Box
      component="span"
      pl={1.5}
    >
      New Message
    </Box>
  </BaseActionTrigger>
)
